import { Backend } from '@/_axios';

export default {
  list(page) {
    return Backend.get('/roles/', { params: { page } });
  },
  editData(roleId) {
    return Backend.get(`/roles/${roleId}/edit`);
  },
  createData() {
    return Backend.get('/roles/create');
  },
  create(createData) {
    return Backend.post('/roles/', createData);
  },
  update(id, updateData) {
    return Backend.put(`/roles/${id}`, updateData);
  },
};
